import React, { useState, useRef } from 'react';
import { QrCode } from 'lucide-react';
import { ToolLayout } from '../../components/ToolLayout';
import { Card, CardContent } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { printPreview } from '../../lib/print';

export default function QRGenerator() {
  const previewRef = useRef(null);
  const [label, setLabel] = useState('Scan for Training Materials');
  const [url, setUrl] = useState('https://example.com/training');
  const [description, setDescription] = useState('Point your camera to access the latest hand hygiene guidance.');
  const [size, setSize] = useState(280);
  const [color, setColor] = useState('0D9488');
  const qrSrc = `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&color=${color}&data=${encodeURIComponent(url)}`;
  return (
    <ToolLayout title="QR Code Generator" subtitle="Scannable codes for materials" icon={QrCode} onPrint={() => printPreview(previewRef.current)}>
      <div className="grid lg:grid-cols-[380px_1fr] gap-6">
        <Card><CardContent className="p-4 space-y-3">
          <div><Label className="text-xs">Label</Label><Input value={label} onChange={(e) => setLabel(e.target.value)} /></div>
          <div><Label className="text-xs">URL / Text</Label><Input value={url} onChange={(e) => setUrl(e.target.value)} /></div>
          <div><Label className="text-xs">Description</Label><Input value={description} onChange={(e) => setDescription(e.target.value)} /></div>
          <div className="grid grid-cols-2 gap-2"><div><Label className="text-xs">Size</Label><Input type="number" value={size} onChange={(e) => setSize(+e.target.value || 200)} /></div><div><Label className="text-xs">Color (hex)</Label><Input value={color} onChange={(e) => setColor(e.target.value.replace('#', ''))} /></div></div>
        </CardContent></Card>
        <div className="border rounded-xl bg-gray-100 p-4">
          <div ref={previewRef} className="onepager-preview bg-white p-10 shadow-lg mx-auto text-center flex flex-col items-center justify-center" style={{ width: '8.5in', minHeight: '11in', fontFamily: 'Inter' }}>
            <h1 className="text-3xl font-bold mb-6" style={{ color: `#${color}` }}>{label}</h1>
            <img src={qrSrc} alt="QR code" className="mx-auto" style={{ width: size, height: size }} />
            <p className="mt-6 text-lg text-gray-600 max-w-md">{description}</p>
            <p className="mt-3 text-sm text-gray-400 break-all">{url}</p>
          </div>
        </div>
      </div>
    </ToolLayout>
  );
}
